import { Breadcrumb } from 'antd';
import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  background-color: #ed143d;
  color: white;
  padding: 2px 5px;
  border-bottom-left-radius: 3px;
  border-top-right-radius: 3px;
  cursor: pointer;
`;

export const Hat = styled.div`
  height: 28px;
  width: 28px;
  position: absolute;
  top: -15px;
  left: -15px;
`;

export const StyledBreadcrumb = styled(Breadcrumb)`
  ol li {
    display: flex;
  }
`;

export const StyledAutoRefreshComponent = styled.div`
  display: flex;
  margin: 0 10px;
  align-items: center;
  justify-content: space-between;
`;

export const StyledAutoRefreshSpan = styled.span`
  padding-right: 0;
  font-size: 14px;
`;
